/**
 * This constant is used on some places in the code where
 * developers might want to make their life easier,
 * by removing something from the UI conditionally (only for local env), e.g. conditional rendering for local env only
 */
import { appRoutes } from '../path';

export const IS_LOCALHOST = window.location.hostname.includes('local.kubit.ai');

// A special flag that is used by Kobol for screenshot capturing feature.
// Kobol will visit Caprica with preset id_token
export const IS_SCREENSHOT_MODE =
  window.location.href.includes('screenshot=true');

// Detect if the app is running in embed mode
export const IS_EMBED_MODE = window.location.pathname.startsWith(
  appRoutes.embed.routePrefix,
);

// use docker
export const BACKEND_URL = window.location.origin;

export const GRAPHQL_URL = `${BACKEND_URL}/graphql`;
export const NOTIFICATIONS_POLLING_INTERVAL = 30000; // 30 seconds
export const CHANNEL_UPDATE_FREQUENCY = 3000; // 3 seconds
export const HIGHLIGHTED_MESSAGE_DURATION = 6000; // 6 seconds

export const DASHBOARD_WORKSPACE_NAME_MAX_LENGTH = 50;
export const CHART_NAME_MAX_LENGTH = 80;
export const DESCRIPTION_MAX_LENGTH = 2048;
export const COMMENT_MAX_LENGTH = 2048;
export const EVENT_NAME_MAX_LENGTH = 50;
export const BUCKET_NAME_MAX_LENGTH = 50;
export const MEASURE_NAME_MAX_LENGTH = 50;
export const SCHEDULE_NAME_MAX_LENGTH = 50;
export const USER_GROUP_NAME_MAX_LENGTH = 50;
export const ROLE_NAME_MAX_LENGTH = 50;
export const SCHEDULE_DESCRIPTION_MAX_LENGTH = 2048;
export const COHORT_NAME_MAX_LENGTH = 50;
export const SUB_FOLDERS_MAX_DEPTH = 2;
export const MAX_FORMAT_DECIMALS = 4;
export const MAX_MEASURE_ROWS = 6;
export const MAX_STEP_COUNT = 10;
export const MAX_EVENT_CONDITIONS_COUNT = 5;
export const MAX_BREAKDOWN_GROUPS = 2;
export const MAX_DATA_TABLE_BREAKDOWN_GROUPS = 5;
export const MAX_GLOBAL_COHORTS = 1;
export const MAX_BREAKDOWN_COHORTS = 5;
export const MAX_COMPOUND_COHORT_SIZE = 3;
export const COHORT_SAMPLE_URL_POSTFIX = '?isAnalysis=true';

export const MAX_MERGE_EVENTS = 3;
export const MAX_EXPAND_EVENTS = 10;
export const MAX_FOLD_EVENTS = 5;

export const MIN_FUNCTION_PERCENTILE = 0;
export const MAX_FUNCTION_PERCENTILE = 100;

export const MIN_TIME_WINDOW = 0;
export const MAX_TIME_WINDOW = 365;

export const MIN_PREDICTION_TIME_WINDOW = 1;
export const MAX_PREDICTION_TIME_WINDOW = 14;

// if a result measure with division formula, apply decimal format to the measure
// to avoid display integer on floats.
export const DEFAULT_RESULT_MEASURE_DECIMALS = 2;

export const MAX_INTEGER = 2147483647;
export const MIN_INTEGER = -2147483648;

export const MAX_FIELD_VALUE_LENGTH = 500;

// this value is prepare for 10 steps funnel chart.
// if the tooltip is too long, it will squeeze the browser with scrollbar
// because the bottom of chart doesn't have enough space to display 10 funnel steps
export const PAGE_BOTTOM_PADDING = '400px';

/**
 * ALL YYYY-MM-DD for store and submit to backend
 */
export const INTERNAL_DATE_FORMAT = 'YYYY-MM-DD';
/**
 * all the chart date is using M/D/YYYY from backend
 */
export const CHART_DATE_FORMAT = 'M/D/YYYY';
export const INTERCOM_APP_ID = 'jzw8066p';

// Userpilot resource center/id
const USERPILOT_RESOURCE_ID = 'TLPtJ-TNDJ';
export const USERPILOT_RESOURCE_CENTER = `resource_center: ${USERPILOT_RESOURCE_ID}`;

export const COMPARISON_KEY_SUFFIX = '-comparison';

// we replace the Overall/[Previous] Overall slice name with Measure/ [Previous] Measure,
// when we only have these
export const COMPARISON_OVERALL_SLICE_NAME = 'Measure';

/**
 * only allow COMPARE and OR when there are two rows in the cohort sample builder
 */
export const ROWS_COUNT_ALLOWS_COMPARE_OR = 2;

export const MAX_STEP_EXCLUDED_EVENTS_COUNT = 5;

export const MAX_MERGE_EVENT_ALIAS_LENGTH = 50;

export const MAX_BREAKDOWN_GROUPS_IN_HISTOGRAM = 1;

export const MAX_FILTER_CONDITIONS = 3;

export const MAX_PREDICATES_IN_FILTER_CONDITION = 25;

export const MAX_DASHBOARD_FILTER_CONDITIONS = 5;

export const MAX_MEASURE_ROLLING_CONTROL_VALUE = 90;

export const MAX_SIGNIFICANCE_VARIANTS = 2;

export const CATEGORY_NAME_MAX_LENGTH = 50;

export const SAMPLE_PERCENTAGE_VALUES = [1, 5, 10, 50, 100];

export const TILE_TITLE_MAX_LENGTH = 50;

export const MIN_SCRATCHPAD_WIDTH = 375;
export const MAX_SCRATCHPAD_WIDTH = MIN_SCRATCHPAD_WIDTH * 2;

/**
 * Internally Kobol can support more than one different implementation of AI prompt processing.
 * Internal Caprica users (QA/PM/CSEs) can switch to that implementation using a specific URL
 * search parameter named like this with a value of TEST, e.g.:
 * ?abTestGroup=TEST
 */
export const LLM_AB_TEST_GROUP_URL_PARAM = 'abTestGroup';
